module.exports = __webpack_public_path__ + "public/img/01.d08fbe3d.png";